module.exports = __webpack_public_path__ + "TRUONGabout-2.cdb958aa.png";